import { createRouter, createWebHashHistory } from "vue-router";
import LoginPage from "../views/LoginPage.vue";
import HomePage from "../views/HomePage.vue";
import RollInfoPage from "../views/RollInfoPage.vue";
import AssemblyPage from "../views/AssemblyPage.vue";
import AssembliesPage from "../views/AssembliesPage.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomePage,
  },
  {
    path: "/login",
    name: "login",
    component: LoginPage,
  },
  {
    path: "/rollinfo",
    name: "rollinfo",
    component: RollInfoPage,
  },
  {
    path: "/assembly",
    name: "assembly",
    component: AssemblyPage,
  },
  {
    path: "/assemblies",
    name: "assemblies",
    component: AssembliesPage,
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
